export default "__VITE_ASSET__JaUdHrGu__"